import { render, staticRenderFns } from "./cardApprove.vue?vue&type=template&id=8ec837d8&scoped=true&"
import script from "./cardApprove.vue?vue&type=script&lang=js&"
export * from "./cardApprove.vue?vue&type=script&lang=js&"
import style0 from "./cardApprove.vue?vue&type=style&index=0&id=8ec837d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec837d8",
  null
  
)

export default component.exports